import { z } from 'zod';
import type { IpgCardTokenizationResponse } from '../../types/ipg/ipg-card-tokenization-response-registry';
import { CardPointeTokenizationResultSchema } from './cardpointe/cardpointe-tokenization.schemas';
import { CloverTokenizationResultSchema } from './clover/clover-tokenization.schemas';
import { ValorCardTokenizationResponseSchema } from './valor/valor-payment.schemas';

export const IpgCardTokenizationResponseSchema: z.ZodType<IpgCardTokenizationResponse> =
    z.union([
        ValorCardTokenizationResponseSchema,
        CardPointeTokenizationResultSchema,
        CloverTokenizationResultSchema,
    ]);
